import * as CookieConsent from "vanilla-cookieconsent";


export const SERVICE_AD_STORAGE = 'ad_storage';
export const SERVICE_AD_PERSONALIZATION = 'ad_personalization';
export const SERVICE_AD_USER_DATA = 'ad_user_data';
export const SERVICE_ANALYTICS_STORAGE = 'analytics_storage';

export const CATEGORY_ANALYTICS = 'analytics';

window.dataLayer = window.dataLayer || [];

export function gtag() {
    window.dataLayer.push(arguments);
}

export function updateGtagConsent(categories, acceptedServices) {
    const consentState = {
        [SERVICE_AD_STORAGE]: CookieConsent.acceptedCategory(categories.ADVERTISEMENT) ? 'granted' : 'denied',
        [SERVICE_AD_PERSONALIZATION]: CookieConsent.acceptedCategory(categories.PERSONALIZATION) ? 'granted' : 'denied',
        [SERVICE_AD_USER_DATA]: CookieConsent.acceptedCategory(categories.ADVERTISEMENT) ? 'granted' : 'denied',
        [SERVICE_ANALYTICS_STORAGE]: acceptedServices.includes(SERVICE_ANALYTICS_STORAGE) ? 'granted' : 'denied',
    };
    gtag('consent', 'update', consentState);
}

export function getGtmConfig(i18n) {
    const lang = i18n.locale;
    const labels = {
        [lang] : i18n.t('tekst Włącza przechowywanie (takie jak pliki cookie) związane z analizą. (cookie consent)'),
    };

    return {
        category: CATEGORY_ANALYTICS,
        service: SERVICE_ANALYTICS_STORAGE,
        config: {
            label: labels[lang] || labels['en']
        },
        cookieTable: {
            body: [
                {
                    name: "_ga",
                    domain: "Google Analytics",
                    description: lang === 'pl' ? "Plik cookie ustawiony przez <a href=\"https://business.safety.google/adscookies/\">Google Analytics</a>" :
                                 lang === 'ua' ? "Файл cookie, встановлений <a href=\"https://business.safety.google/adscookies/\">Google Analytics</a>" :
                                 "Cookie set by <a href=\"https://business.safety.google/adscookies/\">Google Analytics</a>",
                    expiration: lang === 'pl' ? "Wygasa po 12 dniach" :
                                lang === 'ua' ? "Закінчується через 12 днів" :
                                "Expires after 12 days"
                },
                {
                    name: "_gid",
                    domain: "Google Analytics",
                    description: lang === 'pl' ? "Plik cookie ustawiony przez <a href=\"https://business.safety.google/adscookies/\">Google Analytics</a>" :
                                 lang === 'ua' ? "Файл cookie, встановлений <a href=\"https://business.safety.google/adscookies/\">Google Analytics</a>" :
                                 "Cookie set by <a href=\"https://business.safety.google/adscookies/\">Google Analytics</a>",
                    expiration: lang === 'pl' ? "Sesja" :
                                lang === 'ua' ? "Сесія" :
                                "Session"
                }
            ]
        },
        autoClear: {
            cookies: [
                { name: /^(_ga|_gid)/ },
                { name: /^_ga/ },
                { name: '_gid' },
                { name: '_gat' },
                { name: /^_ga_/ },
                { name: /^_dc_gtm_/ },
                { name: 'AMP_' }
            ]
        }
    };
}

export const cookieCallbacks = {
    onFirstConsent: (cookie, utils) => {
        const acceptedServices = Object.values(cookie.services || []).flat();
        const { categories } = utils.getConstants();
        updateGtagConsent(categories, acceptedServices);
    },

    onConsent: (cookie, utils) => {
        const acceptedServices = Object.values(cookie.services || []).flat();
        const { categories } = utils.getConstants();
        updateGtagConsent(categories, acceptedServices);
    },

    onChange: (cookie, changedCategories, changedServices, utils) => {
        const acceptedServices = Object.values(cookie.services || []).flat();
        const { categories } = utils.getConstants();
        updateGtagConsent(categories, acceptedServices);
    }
}
